export default "__VITE_ASSET__c9bb17e8__"